// extracted by mini-css-extract-plugin
module.exports = {"app":"App_app__2ziFi","logo":"App_logo__2qPv-"};